function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { developmentDomains, productionDomains } from "../constants";
import { escapeString } from "./regex";
/**
 * Returns the value of a URL parameter.
 *
 * @param name Name of the parameter to get the value of.
 * @param defaultValue Default value to return if the parameter was not set.
 *
 * @return The value of the URL parameter, or the default value if the parameter did not exist.
 */ export function getUrlParameter(name) {
    var defaultValue = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, parseBool = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var search = typeof window.location === "undefined" ? "" : window.location.search;
    var regExp = new RegExp("[?|&]".concat(escapeString(encodeURI(name)), "=([^&;]*)(&|#|;|$)"));
    var result = regExp.exec(search);
    var returnObject = result ? decodeURIComponent(result[1].replace(/\+/g, "%20")) : defaultValue;
    if (parseBool && typeof returnObject === "string") {
        if ((returnObject === null || returnObject === void 0 ? void 0 : returnObject.toLowerCase()) === "true") {
            returnObject = true;
        } else if ((returnObject === null || returnObject === void 0 ? void 0 : returnObject.toLowerCase()) === "false") {
            returnObject = false;
        }
    }
    return returnObject;
}
export var matchPath = function(pattern, pathname) {
    var patternSegments = pattern.split("/");
    var pathSegments = pathname.split("/");
    if (patternSegments.length !== pathSegments.length) {
        return null;
    }
    var params = {};
    for(var i = 0; i < patternSegments.length; i++){
        if (patternSegments[i].startsWith(":")) {
            var paramName = patternSegments[i].slice(1);
            params[paramName] = pathSegments[i];
        } else if (patternSegments[i] !== pathSegments[i]) {
            return null;
        }
    }
    return params;
};
export var isAbsoluteURL = function(url) {
    return url.startsWith("http://") || url.startsWith("https://");
};
export var makeQuery = function(params) {
    return Object.entries(params).filter(function(param) {
        var _param = _sliced_to_array(param, 2), _ = _param[0], value = _param[1];
        if (typeof value === "string") {
            return value.trim();
        }
        if (Array.isArray(value)) {
            return value.length > 0;
        }
        return value;
    }).map(function(pair) {
        return pair.join("=");
    }).join("&");
};
export var isWhitelistedDomain = function(hostname) {
    return _to_consumable_array(productionDomains).concat(_to_consumable_array(developmentDomains)).some(function(domain) {
        return hostname.endsWith(domain);
    });
};
export var getAPIBaseHost = function(configUrl) {
    if (!configUrl) return "";
    try {
        var url = new URL(configUrl);
        var hostname = window.location.hostname;
        if (isWhitelistedDomain(hostname)) {
            url.hostname = hostname;
        }
        var modifiedUrlString = url.toString();
        if ((url.pathname === "/" || url.pathname === "") && !configUrl.endsWith("/")) {
            modifiedUrlString = modifiedUrlString.replace(/\/$/, "");
        }
        return modifiedUrlString;
    } catch (e) {
        return configUrl;
    }
};

//# sourceMappingURL=url.js.map